import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import EmployeeModel from 'models/Employee';

import Wrapper from './styled/Wrapper';
import Name from './styled/Name';
import Role from './styled/Role';
import Description from './styled/Description';
import ImgWrapper from './styled/ImgWrapper';
import Img from './styled/Img';
import ContentWrapper from './styled/ContentWrapper';

export default class FeaturedTeamMember extends PureComponent {


  static defaultProps = {
    flipped: false,
  };

  static contextType = ThemeContext;

  render() {
    const { className, firstName, lastName, jobtitle, description, image, flipped } = this.props;

    return (
      <Wrapper className={className}>
        <ImgWrapper flipped={flipped}>
          <Img crossOrigin="anonymous" src={image.url} />
        </ImgWrapper>
        <ContentWrapper flipped={flipped}>
          <Name theme={this.context}>
            {firstName} {lastName}
          </Name>
          <Role theme={this.context}>{jobtitle.title}</Role>
          <Description theme={this.context} dangerouslySetInnerHTML={{ __html: description }} />
        </ContentWrapper>
      </Wrapper>
    );
  }
}
